/* eslint-disable react/display-name */
import React from 'react'
import numeral from 'numeral'
import { Query } from 'react-apollo'
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import moment from 'moment'
import {
  Div, H4, P, Loading, SmallText,
} from 'konsys-ui'
import { DisplayTextWhenEmpty } from '../../components/common/apollo-return'
import { theme } from '../../styles/_variables'
import { QUOTATION_LIST } from '../../constants/graph/query'
import {
  Wrapper, HeaderCell, IdCell, TableDiv,
} from './styled'

const checkStatus = (status) => {
  switch (status) {
    case 'quotationRequest': return <SmallText color='#1155CC'>ขอใบเสนอราคา</SmallText>
    case 'quotationReview': return <SmallText color='#6D9EEB'>ตรวจสอบใบเสนอราคา</SmallText>
    case 'waitingForPayment': return <SmallText color='#FFD966'>รอการชำระเงิน</SmallText>
    case 'paymentVerifying': return <SmallText color='#FF9900'>ตรวจสอบการชำระเงิน</SmallText>
    case 'revisingPayment': return <SmallText color='#B45F06'>แก้ไขการชำระเงิน</SmallText>
    case 'paymentVerified': return <SmallText color='#6AA84F'>ยืนยันการชำระเงิน</SmallText>
    case 'designing': return <SmallText color='#A64D79'>ดำเนินการออกแบบ</SmallText>
    case 'artworkCreating': return <SmallText color='#E06666'>ดำเนินการสร้างไฟล์งาน</SmallText>
    case 'printing': return <SmallText color='#38761D'>ดำเนินการผลิต</SmallText>
    case 'shipped': return <SmallText color='#65D4CC'>จัดส่งเรียบร้อย</SmallText>
    case 'refunding': return <SmallText color='#434343'>ดำเนินการคืนเงิน</SmallText>
    case 'refunded': return <SmallText color='#000000'>คืนเงินเรียบร้อย</SmallText>
    case 'paused': return <SmallText color='#B7B7B7'>หยุดชั่วคราว</SmallText>
    case 'cancelled': return <SmallText color='#CC0000'>ยกเลิก</SmallText>
    default: return ''
  }
}

const HistoryTable = ({ onSelect }) => {
  const limit = 10
  const columnsReact = [
    {
      Header: () => <HeaderCell bold>หมายเลขอ้างอิง</HeaderCell>,
      accessor: 'refId',
      Cell: props => <Div textAlign='center' cursor='pointer' onClick={() => onSelect(props.original.quotationId)}><IdCell>{props.value}</IdCell></Div>,
      minWidth: 160,
    }, {
      Header: <HeaderCell>วันที่/เวลา</HeaderCell>,
      accessor: 'createdAt',
      Cell: props => <Div textAlign='center'><SmallText style={{ fontWeight: 'bold' }} color='#646566'>{moment(props.value).format('DD/MM/YY HH:mm')}</SmallText></Div>,
      width: 120,
    },
    // {
    //   Header: <HeaderCell>จำนวน</HeaderCell>,
    //   accessor: 'quantity',
    //   Cell: props => <Div textAlign='center'><P style={{ fontWeight: 'bold' }} color='#646566'>{props.value ? props.value : '-'}</P></Div>,
    //   width: 100,
    // },
    // {
    //   Header: <HeaderCell>ราคา</HeaderCell>,
    //   accessor: 'totalPrice',
    //   Cell: props => <Div textAlign='center'><SmallText style={{ fontWeight: 'bold' }} color='#646566'>{props.value ? numeral(props.value).format('0,0.00') : '-'}</SmallText></Div>,
    // },
    {
      Header: <HeaderCell>สถานะ</HeaderCell>,
      accessor: 'status',
      Cell: props => <Div style={{ overflow: 'hidden' }} textAlign='center'>{checkStatus(props.value)}</Div>,
      minWidth: 130,
    },
  ]

  return (
    <Div>
      <Div textAlign='left'>
        <H4 margin='0 0 16px' color={theme.color.tertiaryColor}>ตรวจสอบประวัติคำขอใบเสนอราคา และคำสั่งพิมพ์</H4>
      </Div>
      <Wrapper>
        <Query
          query={QUOTATION_LIST}
          fetchPolicy='cache-and-network'
          variables={{
            limit: 1000000,
          }}
        >
          {
            ({
              data, loading, error,
            }) => {
              if (error) return <DisplayTextWhenEmpty error />
              if (loading) return <Loading fullWidth center />
              if (data && data.quotationList.totalCount === 0) return <DisplayTextWhenEmpty text='ยังไม่มีประวัติคำขอใบเสนอราคา และคำสั่งพิมพ์' />
              return (
                <TableDiv>
                  <ReactTable
                    data={data.quotationList.list}
                    columns={columnsReact}
                    showPageSizeOptions={false}
                    resizable={false}
                    minRows={data.quotationList.list.length < limit ? data.quotationList.list.length : limit}
                    sortable={false}
                    defaultPageSize={limit}
                  />
                  {
                    loading && <Div margin='32px 0 0'><Loading fullWidth center /></Div>
                  }
                </TableDiv>
              )
            }
          }
        </Query>
      </Wrapper>
    </Div>
  )
}


export default HistoryTable



// WEBPACK FOOTER //
// ./src/pages/history-page/index.jsx